import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@tcc-mono/shared/authentication/passport';

const routes: Routes = [
  {
    path: 'app',
    loadChildren: () =>
      import('@tcc-mono/classifact/web/home/feature').then(
        m => m.HomePageModule
      ),
    canActivate: [AuthGuard]
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('@tcc-mono/shared/authentication/passport').then(
        m => m.AuthenticationModule
      )
  },
  {
    path: '',
    redirectTo: 'app',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class ClassifactWebShellFeatureRoutingModule { }
